import React from 'react';
import { Text } from 'widget/components';

interface SystemMessage {
  children: React.ReactNode;
}

const SystemMessage = ({ children }: SystemMessage) => (
  <div className="whatcrm-widget-system-message">
    <Text color="navy" textAlign="center">
      {children}
    </Text>
  </div>
);

export default SystemMessage;
